<template>
    <div class="dashboard">
        <div style="width: calc(100% - 20px);position:relative;border:1px solid #c0c0c0;margin: 60px 10px;height:195px;float: left;display: flex;justify-content: space-evenly;padding: 10px 0px;">
            <img :src="dashBanner" />
        </div>
        <div style="width: calc(100% - 20px);border:1px solid #c0c0c0;margin: 10px;float: left">
            <header><p style="text-align: center;font-weight: bold;font-size: 25px;margin: 10px;">Members</p></header>
            <div class="db-search">
            </div>
            <div class="customer-list list-header" @keyup="searchCustomers()">
                <div></div>
                <div>
                    <p>STATUS</p>
                    <input v-model="search.closed.value" />
                </div>
                <div>
                    <p>Name</p>
                    <input v-model="search.name.value" />                    
                </div>
                <div>
                    <p>Member #</p>
                    <input v-model="search.customerNo.value" />
                </div>
                <div>
                    <p>Joined</p> 
                    <input v-model="search.joined.value"/>                    
                </div>  
                <div>
                    <p>Mobile</p>
                    <input v-model="search.phone.value" />  
                </div>                               
                <div>
                    <p>Email</p>
                    <input v-model="search.email.value" />  
                </div>
                <div>
                    <p class="ta-r mr-10">Visits</p>
                    <input v-model="search.landed.value"/>  
                </div>
                <div>
                    <p class="ta-r mr-10">Opens</p>
                    <input v-model="search.opens.value" />  
                </div>
                <div>
                    <p class="ta-r mr-10">Ads</p>
                    <input v-model="search.ads.value" />  
                </div>
                <div>
                    <p class="ta-r mr-10">Sent</p>
                    <input v-model="search.sent.value" />  
                </div>
                <div>
                    <p class="ta-r mr-10">Stamps</p> 
                    <input v-model="search.loyaltyQty.value" />                     
                </div>
                <div>
                    <p class="ta-r mr-10">Redeems</p>
                    <input v-model="search.redeemCount.value" />  
                </div> 
                <div>
                    <p class="ta-r mr-10">Last Act.</p>
                    <input v-model="search.active.value" />  
                </div> 
            </div>
            <div class="list-main">
                <div v-for="customer in customers">
                    <div class="customer-list">
                        <div :class="['gt',{ open: customer.open }]" @click="showCustomerDetail(customer)"></div>
                        <p @click="deleteCustomer(customer)">{{ customer.closed ? ( 'CLOSED '+ PAdate(customer.closed).time_date ) : 'ACTIVE' }}</p>
                        <p class="td-ulb" @click="editCustomer(customer)">{{ customer.name }}</p>
                        <p>{{ customer.customerNo }}</p>
                        <p>{{ PAdate(customer.joined).time_date }}</p>
                        <p :class="{ 'no-sms': customer.sendSMS === false }">{{ prettyPhone(customer.msisdn) }}</p>
                        <p>{{ customer.email }}</p>
                        <p class="ta-r mr-10">{{ customer.landed }}</p>
                        <p class="ta-r mr-10">{{ customer.opens }}</p>
                        <p class="ta-r mr-10">{{ customer.ads.filter(ad => !ad.dateRedeemed).length }}</p>
                        <p class="ta-r mr-10">{{ customer.sent }}</p>
                        <p class="ta-r mr-10">{{ customer.stampQty }}</p>
                        <p class="ta-r mr-10">{{ customer.redeemCount }}</p>
                        <p class="ta-r mr-10">{{ PAdate(customer.active).time_date }}</p>
                    </div>
                    <div v-if="customer.open" style="float: left;width: calc(100% - 20px);margin:9px;border:1px solid #c0c0c0;background-color: white;">
                        <div>
                            <div class="dashboard-summary">
                                <header><p>Competition Entries</p></header>
                                <div v-for="ad in customer.entries" :key="ad._id" class="live-coupons" style="width: 100%;float: left; display: grid;grid-template-columns: 150px 300px 220px 700px;">
                                    <p class="btn" @click="removeEntry({ customer, ad })">remove</p>
                                    <p>{{ ad.title }}</p>
                                    <p>{{ PAdate(ad.date).time_date }}</p>
                                    <p>{{ ad.code }}</p>
                                </div>
                            </div>
                            <div class="dashboard-summary">
                                <header><p>Live Coupons</p></header>
                                <div v-for="ad in (customer.ads || []).filter(ad => !ad.dateRedeemed)" :key="ad.coupon_id" class="live-coupons" style="width: 100%;float: left; display: grid;grid-template-columns: 150px 300px 220px 700px;">
                                    <p class="btn" @click="removeAd({ customer, ad })">remove</p>
                                    <p>{{ ad.field }}</p>
                                    <p>{{ PAdate(ad.date).time_date }}</p>
                                    <p></p>
                                </div>
                            </div>
                            <div class="dashboard-summary">
                                <header><p>Redeemed Coupons</p></header>
                                <div v-for="ad in (customer.redeemRewards || []).concat(customer.ads.filter(ad => ad.dateRedeemed)).reverse()" :key="ad.coupon_id" class="live-coupons" style="width: 100%;float: left; display: grid;grid-template-columns: 150px 300px 220px 700px;">
                                    <p class="btn" style="opacity: 0;" @click="removeRemoveAd({ customer, ad })"> remove</p>
                                    <p>{{ ad.title }}</p>
                                    <p>{{ PAdate(ad.now).time_date }}</p>
                                    <!-- <p>{{ !ad.staff ? getStaffName(ad.user_id,name => ad.staff = name) : ad.staff }}</p> -->
                                    <p>{{ ad.staff }}</p>
                                </div>
                            </div>
                            <div class="dashboard-summary">
                                <header><p>Loyalty Awards</p></header>
                                <div class="dashboard-summary-title" style="display:grid;grid-template-columns: 90px 200px 220px;grid-column-gap: 10px;font-weight: bold;">
                                    <p>Stamps</p>
                                    <p>Date</p>
                                    <p>Staff</p>
                                </div>
                                <div class="dashboard-summary-items">
                                    <div v-for="award in ( customer.loyaltyAwards || []).map(a => a).reverse()" style="display:grid;grid-template-columns: 90px 200px 220px;grid-column-gap: 10px;">
                                        <p class="ta-r" style="position: relative;left:-20px">{{ award.qty }}</p>
                                        <p>{{ PAdate(award.now).time_date }}</p>
                                        <p>{{ award.date.startsWith('2') ? getStaffName(award.user_id,name => { award.date = name }) : award.date }}</p>
                                    </div>
                                </div>
                            </div>                            
                        </div>
                    </div>
                </div>
                <div class="btns">
                    <p class="btn" style="margin-top:10px;width: 140px;" @click="dataStudioDownload">dasher down</p>
                    <p class="btn" style="margin-top:10px;width: 140px;" @click="download('customers')">download</p>
                    <p class="btn" style="width: 140px;margin-top: 10px;" @click="sendSMS('customers')">send sms</p>
                    <p style="position:absolute;right:170px;margin-top: 16px;">Member Count {{ customerCount }}</p><p @click="showAll('customers')" style="margin:10px;width:140px" class="btn">{{ showAllcustomers ? 'show less' : 'show all' }}</p>
                </div>
            </div>
        </div>
        <div style="width: calc(100% - 20px);border:1px solid #c0c0c0;margin: 10px;float: left;">
            <header><p style="text-align: center;font-weight: bold;font-size: 25px;margin: 10px;">Staff</p></header>
            <div class="staff-list list-header" @keyup="searchUsers($event)">
                <div>  
                    <div></div>
                    <div>
                        <p>Status</p>
                        <input v-model="staff.status.value" />
                    </div>
                    <div>
                        <p>Name</p>
                        <input v-model="staff.name.value" />
                    </div>
                    <div>
                        <p>Number</p>
                        <input v-model="staff.staffNo.value" />
                    </div>
                    <div>
                        <p>Mobile</p>
                        <input v-model="staff.phone.value"  />
                    </div>
                    <div>
                        <p>Username</p>
                        <input v-model="staff.username.value"  />
                    </div>
                    <div>
                        <p>Created</p>
                        <input v-model="staff.created.value" />
                    </div>
                    <div>
                        <p>Verified</p>
                        <input v-model="staff.verified.value" />
                    </div>
                    <div>
                        <p>Stamps</p>
                        <input v-model="staff.stamps.value" />
                    </div>
                    <div>
                        <p>Redemptions</p>
                        <input v-model="staff.redeemCount.value"  />
                    </div>
                    <div>
                        <p>Last Active</p>
                        <input v-model="staff.lastActive.value" />
                    </div>
                </div>
            </div>
            <div class="list-main">
                <div v-for="staff in users" class="staff-list">
                    <div>     
                        <p :class="['gt',{ open: staff.open }]" @click="showStaffDetail(staff)"></p>
                        <p>ACTIVE</p>
                        <p class="td-ulb" :style="{ color: staff.suspend ? 'red' : 'blue' }" @click="editStaff(staff)">{{ staff.name }}</p>
                        <p>CH-{{ staff.staffNo }}</p>
                        <p>{{ staff.prettyPhone }}</p>
                        <p>{{ staff.username }}</p>
                        <p>{{ PAdate(staff.created).time_date }}</p>
                        <p>{{ staff.Verified ? PAdate(staff.Verified).time_date : 'Not Verified' }}</p>
                        <p>{{ staff.loyaltyQty }}</p>
                        <p>{{ staff.redeemReward }}</p>
                        <p class="ellip">{{ PAdate(staff.active).time_date }}</p>
                    </div>
                    <div v-if="staff.open" style="float: left;width: calc(100% - 20px);margin:9px;border:1px solid #c0c0c0;background-color: white;">
                        <div>
                            <div class="dashboard-summary">
                                <div class="dashboard-summary-title" style="display: grid;grid-template-columns: 220px 220px 400px">
                                    <p>Member</p>
                                    <p>Date</p>
                                    <p>Voucher</p>
                                </div>
                                <div class="dashboard-summary-items">
                                    <div v-for="voucher in (staff.redeemRewards || []).map(c => c).reverse()" style="display: grid;grid-template-columns: 220px 220px 400px">
                                        <p>{{ getCustomerName(voucher.customer_id,name => voucher.name = name) }}</p>
                                        <p>{{ PAdate(voucher.now).time_date }}</p>
                                        <p>{{ getAdTitle(voucher.ad_id,title => voucher.title = title) }}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="dashboard-summary">
                                <div class="dashboard-summary-title" style="display: grid;grid-template-columns: 220px 220px 400px">
                                    <p>Member</p>
                                    <p>Date</p>
                                    <p>Stamps</p>
                                </div>
                                <div class="dashboard-summary-items">
                                    <div v-for="stamp in (staff.loyaltyAwards || []).map(c => c).reverse()" style="display: grid;grid-template-columns: 220px 220px 90px" >
                                        <p>{{ stamp.date.startsWith('2') ? getCustomerName(stamp.customer_id,name => stamp.date = name) : stamp.date }}</p>
                                        <p>{{ PAdate(stamp.now).time_date }}</p>
                                        <p class="ta-r" style="position: relative;left:-20px">{{ stamp.qty }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="btns">
                    <p class="btn" style="float: left;margin:10px;width: 140px;" @click="download('users')">download</p>
                    <p class="btn" style="float: left;margin:10px;width: 140px;" @click="addStaff()">new staff</p>
                    <p class="btn" style="margin:10px;width:140px" @click="showAll('users')">{{ showAllusers ? 'show less' : 'show all' }}</p>
                </div>
            </div>
        </div>
       <div style="width: calc(100% - 20px);border:1px solid #c0c0c0;float: left;margin: 10px">
            <header style="position: relative;"><p class="btn" style="width: 140px;margin: 0px 10px;position: absolute;" @click="makeNewCampaign()">new</p><p style="text-align: center;font-weight: bold;font-size: 25px;margin: 10px;">Campaigns</p></header>
           <div v-for="campaign in campaigns.filter(c => c.live)" :key="campaign._id" style="width: calc(100% - 20px);float: left;margin: 5px;border:1px solid #c0c0c0;padding:5px;" @mouseenter="enterCampaign(campaign)" >
                <div style="width:calc(100% - 20px;float:left;display:grid;grid-template-columns:320px 100px 100px 100px">
                    <p style="font-weight: bold;">{{ campaign.title }}</p>                
                    <p>Sent {{ campaign.qtySent }}</p>
                    <p>Opens {{ Object.keys(campaign.uniqueOpens || {}).length }}</p>
                    <p>Redeems {{ campaign.redeemCount }}</p>
                </div>
                <div v-if="!campaign.hide" v-for="page in campaign.pages" :key="page.code" style="float: left;width: calc(414px * 0.7 + 22px);height: 370px;">
                    <div style="position: relative;">
                        <div class="grab" @mousedown="downMove($event,campaign,page)" @mousemove="moveMove($event,campaign,page)" @mouseup="upMove($event,campaign,page)" ></div>
                        <Voucher :voucher="page" />
                        <div :style="{ backgroundColor: page.removed ? 'red' : '' }" class="remove-x" @click="remove($event,campaign,page)"></div>
                    </div>
                </div>
                <div class="btns" :style="{ marginTop: campaign.pages.length == 0 ? '320px' : '0px' }" >
                    <p class="btn del" @click="deleteCampaign(campaign)">delete</p>
                    <p class="btn" @click="editCampaign(campaign)" style="float: right;">edit</p>
                    <!-- <p class="btn" @click="campaign.hide = !campaign.hide" style="float: right;">{{ campaign.hide ? 'show' : 'hide' }}</p> -->
                    <p class="btn" @click="sendCampaign(campaign)" style="float:right">SEND</p>
                    
                </div>
           </div>
       </div>
       <div style="width: calc(100% - 20px);border:1px solid #c0c0c0;float:left;margin:10px;display:none">
           <header><p style="text-align: center;font-weight: bold;font-size: 25px;margin: 10px;">Vouchers</p></header>
           <div v-for="ad in ads" style="width: 140px;float:left;margin: 10px;">
                <img :src="ad.src" style="width: calc(100% - 10px);margin: 10px" />
                <p>Clicks {{ ad.clicks }}</p>
                <p>Redeemed {{ ad.redeemCount }}</p>
           </div>
       </div>
       <div v-if="removePage" class="v-alert" style="height: 538px;">
            <header><p>Remove Ad</p><div class="x" @click="removePage = false"></div></header>
            <Voucher style="position: absolute;z-index: -1;" :voucher="removePage" />
            <div class="label" style="margin-top: 380px;">
                <p style="width: calc(100% - 40px);float: right;margin-top: 5px;">Remove from All Members</p>
                <input type="checkbox" v-model="removeFromCustomers"/>
            </div>
            <div style="position: relative;z-index: 30;">
                <div class="label">
                    <p style="width: calc(100% - 40px);float: right;margin-top: 5px;">Remove from Campaign</p>
                    <input type="checkbox" v-model="removeFromCampaign"/>
                </div>                 
                <div class="btns">
                    <p class="btn red" @click="removePageNow(removePage)">remove</p>
                </div> 
            </div>          
       </div>
       <div v-if="campaign" class="v-alert" style="width: 600px;margin-left:-300px">
            <header><p>Campaign</p><div class="x" @click="campaign = false"></div></header>
            <div>
                <div class="label">
                    <p>Title</p>
                    <input v-model="campaign.title" />
                </div>
            </div>
            <div class="btns">
                <p class="btn del" @click="deleteCampaign(campaign)">delete</p>
                <p class="btn" @click="saveCampaign(campaign)">save</p>
            </div>
       </div>
       <div v-if="sendingCampaign" class="v-alert">
            <header><p>{{ sendBoxHeader }}</p><div class="x" @click="sendingCampaign = false"></div></header>
            <div>
                <p style="font-weight: bold;text-align: center;margin: 10px 0px">{{ sendingCampaign.title }}</p>
                <div class="label">
                    <p>Text Message</p>
                    <textarea v-model="sendingMessage" style="width: calc(100% - 15px);min-width: calc(100% - 15px);max-width: calc(100% - 15px);min-height: 100px;padding:5px;font-size: 18px;"></textarea>
                </div>
                <div class="label">
                    <p style="width: 100px;float: left;margin-top:5px">Send Text</p>
                    <input v-model="sendText" type="checkbox" style="float: left;" />
                </div>
            </div>
            <div style="float: left;width: calc(100% - 20px);margin: 10px">
                <p v-for="customer in selectedCustomers" style="display: grid;grid-template-columns: 1fr 1fr;line-height: 22px;"><span>{{ customer.name }}</span><span style="text-align: right;">{{ customer.prettyPhone }}</span></p>
            </div>
            <div class="btns">
                <p class="btn" @click="selectCustomers()">select</p>
                <p class="btn" @click="sendToCustomers(selectedCustomers)">send {{ selectedCustomers.length == 0 ? 'all' : selectedCustomers.length }}</p>
            </div>
       </div>
       <div v-if="newStaff" class="v-alert" style="width:600px;margin-left:-300px;top:50px;">
            <header><p>Edit Staff</p><div class="x" @click="newStaff = false"></div></header>
            <div>
                <div class="label">
                    <p>Name</p>
                    <input v-model="newStaff.name" />
                </div>
                <div class="label">
                    <p>Username</p>
                    <input v-model="newStaff.username" />
                </div>
                <div class="label">
                    <p>Email</p>
                    <input v-model="newStaff.email" />
                    <p class="btn" style="display: none;" @click="sendInvite('email',newStaff)">send invite</p>
                </div>
                <div class="label">
                    <p>Mobile</p>
                    <input v-model="newStaff.mobile" />
                    <p class="btn" style="display: none;" @click="sendInvite('sms',newStaff)">send invite</p>
                </div>

                <div class="label checkbox">
                    <p>Suspend</p>
                    <input v-model="newStaff.suspend" type="checkbox" />
                </div>
                <div class="label checkbox">
                    <p>Dashboard</p>
                    <input v-model="newStaff.dashboard" type="checkbox" />
                </div>
                <div class="label" style="display: none;">
                    <p>Notes</p>
                    <textarea v-model="newStaff.notes"></textarea>
                </div>
            </div>
            <div class="btns">
                <p class="btn del" @click="deleteStaff(newStaff)">delete</p><p @click="saveStaff(newStaff)" class="btn">save</p>
            </div>
       </div>
       <div v-if="offers" style="position: fixed;top:90px;left:100%" :class="['current-offers',{ 'show-open': showCurrent }]" @click="showCurrent = !showCurrent">
            <div style="width: 120px;background-color: rgba(0,255,0,1);height: 40px;border:1px solid black;position: absolute;">
                <div class="hide" style="float: left;background-color: rgba(0,255,0,1);"></div>
                <p style="float: left;line-height: 40px;font-size: 20px;">Offers</p>
            </div>
            <div class="offers-scroller" style="width: 313px;background-color: white;position: absolute;left:120px; ;padding:10px;height:calc(100vh - 90px);overflow-y: scroll;border: 1px solid black">
                <div v-for="page in offers.pages" :key="page.code" style="float: left;width: calc(414px * 0.7 + 22px);height: 370px;">
                    <div style="position: relative;">
                        <div class="grab" @mousedown="downMove($event,offers,page)" @mousemove="moveMove($event,offers,page)" @mouseup="upMove($event,offers,page)" ></div>
                        <Voucher :voucher="page" />
                        <div class="remove-x" @click="remove($event,offers,page)"></div>
                    </div>
                </div>
            </div>
       </div>
        <div v-if="csv" class="v-alert">
            <header><p>Download</p><div class="x" @click="csv = false"></div></header>
            <div style="float: left;margin: 20px;width:calc(100% - 40px)">
            <p style="text-align: center;">{{ fileName }}</p>
            <p style="text-align: center;margin-top:20px;width: 100%;"><a :download="fileName" :href="csv">download</a></p>
            </div>
        </div>
    </div>
</template>

<script>

import Alert from '@/utils/Alert.js'
import WebSoc from '@/utils/WebSoc.js'
import { formatDate, _date } from '@/utils/DateUtils.js'
import prettyPhone from '@/utils/prettyPhone.js'
import { mapActions } from 'vuex';
import editCustomer from '@/utils/EditCustomer.js'
import getStaffName from '@/utils/getStaffName.js';
import getCustomerName from '@/utils/getCustomerName.js';
import getAdTitle from '@/utils/getAdTitle.js'
import Voucher from '@/components/Voucher.vue';
import getCampaignPageCode from '@/utils/getCampaignPageCode.js';
import selectCustomers from '@/utils/SelectCustomers.js'

const PAdate = _date;

export default {
    name: 'dashboard',
    components: {
        Voucher
    },
    computed: {
        users () { return this.$store.state.DB.users },
        customers () { return this.$store.state.DB.customers },
        ads () { return this.$store.state.DB.ads },
        campaigns () { return this.$store.state.DB.campaigns },
        customerCount () { return this.$store.state.customerCount },
        client_id () { return this.$store.state.client_id },
        offers () { return this.$store.state.currentOffers },
        userCount () { return this.$store.state.userCount },
        dashBanner () { return this.$store.state.dashBanner }
    },
    data () {
        return {
            showCurrent: false,
            PAdate,
            getStaffName,
            getCustomerName,
            getAdTitle,
            formatDate,
            prettyPhone,
            client: false,
            moving: false,
            removePage: false,
            removeFromCustomers: false,
            removeFromCampaign: false,
            sendingCampaign: false,
            sendingMessage: '',
            sendText: true,
            newStaff: false,
            selectedCustomers: [],
            showAllcustomers: false,
            showAllusers: false,
            campaign: false,
            search: {
                closed: { value: '', onsearch: (search) => {  } },
                name: { value: '' },
                customerNo: { value: '', type: 'num' },
                joined: { value: '', type: 'date' },
                phone: { value: '' },
                email: { value: '' },
                landed: { value: '', type: 'num' },
                opens: { value: '', type: 'num' },
                ads: { value: '', onsearch: (search) => {  } },
                sent: { value: '', type: 'num' },
                loyaltyQty: { value: '', type: 'num' },
                redeemCount: { value: '', type: 'num' },
                active: { value: '', type: 'date' }
            },
            staff: {
                status: { value: '' },
                active: { value: ''  },
                name: { value: '' },
                staffNo: { value: '', onsearch: (search) => { var value = search.split('').filter(n => !isNaN(n)).join(''); return !isNaN(value) ? { $eq: parseInt(value) } : '' } },
                phone: { value: '' },
                username: { value: '' },
                created: { value: '' },
                verified: { value: '' },
                stamps: { value: '', type: 'num' },
                redeemCount: { value: '', type: 'num' },
                lastActive: { value: '', type: 'date' }
            },
            csv: false,
            fileName: '',
            sendBoxHeader: ''
        }
    },
    created () {
    },
    mounted () {
        this.getDashboard(this.client_id);
        console.log('setTimeout !!');
        setTimeout(() => {
            //this.$el && this.$el.parentElement ? (this.$forceUpdate(),console.log('forceUpdate') ) : clearInterval(interval);
            console.log('this.offers.pages',this.offers.pages);
            this.offers.pages.forEach((p,i) => console.log('Dashboad',i,p.campaign_id));
        },5000);

    },
    methods: {
        sendSMS ( type ) {
            this.sendBoxHeader = 'Send SMS';
            this.sendingCampaign = type;
            this.selectedCustomers = [];
            this.sendText = true;            
        },
        dataStudioDownload () {
            WebSoc.SEND('dataStudioDownload',{},resp => {
                console.log('resp',resp);
            })
        },
        download ( DB ) {
            WebSoc.SEND({ t: 'dashboardDownload', data: { DB, client_id: this.client_id }},csv => {
                DB = DB == 'users' ? 'staff' : 'customers';
                this.fileName = PAdate(Date.now()).time_date+'-'+DB+'.csv';
                this.csv = URL.createObjectURL(new Blob([csv.map(r => '"'+r.map(f => (f+'').replace(/"/g,'').replace(/,/g,'')).join('","')+'"').join('\n')],{ type: 'text/csv;charset=utf-8;' }));
                console.log(this.csv);
            });
        },
        showAll ( DB ) {
            var showAll = this['showAll'+DB] = !this['showAll'+DB];
            console.log('showAll',showAll);
            if ( DB == 'customers' ) {
                Object.keys(this.search).forEach(key => this.search[key].value = '');
                this.dbSearch({
                    limit: showAll ? 0 : 10,
                    db: this.client_id+'-customers',
                    search: this.search
                });
            }
            if ( DB == 'users' ) {
                this.dbSearch({
                    limit: showAll ? 0 : 10,
                    db: 'users',
                    search: { client_id: { value: this.client_id } }
                });
            }
        },
        addStaff () {
            this.initialStaff = false;
            this.newStaff = {
                suspend: false,
                dashboard: false,
                name: '',
                phone: '',
                email: '',
                client_id: this.client_id,
                username: '',
            }
        },
        editStaff ( user ) {
            user.dashboard = user.dashboard || false;
            this.initialStaff = JSON.stringify(user);
            this.newStaff = JSON.parse(this.initialStaff);
        },
        saveStaff ( user, cB ) {
            this.newStaff = false;
            if ( this.initialStaff ) {
                var initialStaff = JSON.parse(this.initialStaff);
                var update = ['email','mobile','name','username','notes','suspend','dashboard'].reduce((p,f) => {
                    if ( initialStaff[f] != user[f] ) { p[f] = user[f] };
                    return p;
                },{});
                if ( Object.keys(update).length == 0 && typeof cB == 'function' ) return cB(user);
                if ( Object.keys(update).length == 0 ) return this.newStaff = false; 
                return WebSoc.SEND({ t: 'saveClientStaff', data: { DB: 'users', _id: user._id, update }},resp => {
                    if ( resp.errorMessage ) { this.newStaff = user; return Alert.message(resp.errorMessage); }
                    typeof cB == 'function' && cB(user);
                })
            }
            WebSoc.SEND({ t: 'saveClientStaff', data: { DB: 'users', new: user }},resp => {
                console.log('saveClientStaff resp',resp);
                if ( resp.errorMessage ) { this.newStaff = user; return Alert.message(resp.errorMessage); }
                if ( resp.success ) return Alert.message('Added '+user.name);
            })
            
            
        },
        deleteStaff ( user ) {
            if ( !user._id ) return this.newStaff = false;
            Alert.yesno('Delete '+user.name+' ?',yes => {
                if ( !yes ) return;
                this.newStaff = false;
                WebSoc.SEND({ t: 'deleteClientStaff', data: { _id: user._id }},resp => {

                })
            })
            
        },
        sendInvite ( type, user ) {
            var that = this;
            this.newStaff = false;

            if ( !user._id ) return this.saveStaff( user ,user => {
                sendInvite(user);
            });
            
            sendInvite(user)

            function sendInvite(user) {
                
                if ( type == 'sms' && !user.msisdn ) {
                    this.newStaff = user;
                    return Alert.message('Please provide a valid mobile number for '+user.name+'.');
                }
                WebSoc.SEND({ t: 'sendStaffInvite', data: { type, user }},resp => {

                })
            }
        },
        sendToCustomers ( customers ) {
            if ( this.sendText && !this.sendingMessage ) return Alert.message('You must provide a Message');
            var campaign = this.sendingCampaign;
            var client_id = this.client_id;
            if ( customers.length == 0 ) {
                return Alert.yesno('Send to '+this.customerCount+' members?',yes => {
                    WebSoc.SEND('sendCampaign',{ _id: campaign._id, client_id, customers: customers, message: this.sendingMessage, sendText: this.sendText },resp => {
                        console.log('sendCampaign',resp);
                        if ( resp.error ) return Alert.message(resp.error);
                        Alert.message('Sent');
                    });
                });
            }
            this.selectedCustomers = [];
            this.sendingCampaign = false;
            WebSoc.SEND('sendCampaign',{ _id: campaign._id, client_id, customers: customers, message: this.sendingMessage,sendText: this.sendText },resp => {
                console.log('sendCampaign',resp);
                if ( resp.error ) return Alert.message(resp.error);
                Alert.message('Sent')
            })
            
        },
        sendCampaign ( campaign ) {
            this.sendBoxHeader = 'Send Campaign';
            this.sendingCampaign = campaign;
            this.selectedCustomers = [];
            this.sendText = true;
        },
        selectCustomers() {
            selectCustomers({ client_id: this.client_id, current: this.selectedCustomers },customers => {
                this.selectedCustomers = customers;
            })
        },
        remove ( e, campaign, page ) {

            if ( page.removed && e.shiftKey ) {
                page.removed = false;
                e.preventDefault();
                e.stopPropogation();
                return  this.updateCampaign({
                            campaign,
                            unRemovePage: page
                        });;

            }

            if ( page.removed ) {
                return Alert.yesno('Remove PERMANENTLY from Campaign?',yes => {
                    if ( !yes ) return;
                    campaign.pages = campaign.pages.filter(P => P != page)
                    this.updateCampaign({
                        permRemovePage: page,
                        campaign
                    });
                })
            }

            this.removeFromCustomers = false;
            this.removeFromCampaign = true;
            this.removeCampaign = campaign;
            this.removePage = page;
        },
        removePageNow ( page ) {
            var { removeFromCampaign, removeFromCustomers } = this;
            page.removed = true;
            //removeFromCampaign && ( this.removeCampaign.pages = this.removeCampaign.pages.filter(P => P != page) );
            this.removePage = false;
            this.updateCampaign({
                campaign: this.removeCampaign,
                removePage: page,
                removeFromCampaign,
                removeFromCustomers
            });;
        },
        enterCampaign ( toCampaign ) {
            var moving = this.moving;
            if ( !moving ) return;
            var sourceCampaign = moving.campaign;
            var sourcePage = moving.page;
            var newPage = JSON.parse(JSON.stringify(sourcePage));
                newPage.campaign_id = toCampaign._id;
            if ( sourceCampaign != toCampaign ) {
                this.moving = false;
                getCampaignPageCode(toCampaign,code => {
                    newPage.code = code;
                    toCampaign.pages.push(newPage);
                    this.updateCampaign({
                        campaign: toCampaign,
                        addPage: newPage
                    });
                });
            } 
        },
        downMove ( e, campaign, page ) {
                e.preventDefault();
            var src = e.target;
            var ele = src.parentElement;
            var pos = ele.getBoundingClientRect();
            var box = ele.parentElement;
            var container = box.parentElement;
            var parentPos = container.getBoundingClientRect();
            var boxPos = box.getBoundingClientRect();
                ele = ele.cloneNode(true);
                ele.classList.add('ad-mover');
                ele.style.position = 'Fixed';
                ele.style.top = pos.top+'px'
                ele.style.left = pos.left+'px';
                ele.style.opacity = 0.8;
                this.moving = { offers: container.classList.contains('offers-scroller'), ele: ele, startX: e.clientX, startY: e.clientY, x: e.clientX, y: e.clientY, left: pos.left, top: pos.top, width: boxPos.width + 20, height: boxPos.height, campaign: campaign, page: page, row: parseInt(parentPos.width / (boxPos.width + 20)), currentPOS: campaign.pages.indexOf(page), parentTop: parentPos.top, parentWidth: parentPos.width, parentHeight: parentPos.height }
                //this.moving.offers && ( this.moving.height = this.moving.height / 1.3);
                document.body.appendChild(ele);
                ele.addEventListener('mousemove',(e) => this.moveMove(e,campaign,page)); 
                ele.addEventListener('mouseleave',(e) => this.upMove(e,campaign,page)); 
                ele.addEventListener('mouseup',(e) => this.upMove(e,campaign,page));  
        },
        upMove ( e, campaign, page ) {
            var moving = this.moving;
        
            if ( moving ) {
                var ele = moving.ele;
                ele && document.body.removeChild(ele);
                setTimeout(() => {
                    moving.ele == this.moving.ele && ( this.moving = false );
                },1000)
            }
        },
        moveMove ( e, campaign, page ) {
            if ( !this.moving ) return;
            e.preventDefault();
            var moving  = this.moving, that = this;
            var ele     = moving.ele;
            var x = e.clientX - moving.x;
            var y = e.clientY - moving.y;
                ele.style.left = moving.left + x + 'px';
                ele.style.top = moving.top + y + 'px';
                if ( !e.shiftKey ) return;
                if ( e.clientY - moving.parentTop < 0 ) return;
                if ( ( moving.parentTop + moving.parentHeight ) - e.clientY < 0 ) return;
                if ( moving.startX - e.clientX > ( moving.width / 2 ) )   moveLeft(-1)
                if ( moving.startX - e.clientX < - ( moving.width / 2 ) ) moveLeft(+1)
                if ( moving.startY - e.clientY > ( moving.height / 2 ) )   moveTop(-1);
                if ( moving.startY - e.clientY < - ( moving.height / 2 ) ) moveTop(+1)
                function moveLeft(dir) {
                    campaign.pages.splice(campaign.pages.findIndex(p => p.code == page.code),1);
                    campaign.pages.splice(moving.currentPOS += dir,0,page);
                    moving.startX = e.clientX + ( ( moving.width / 2 ) * dir );
                    that.updatePages({
                        campaign,
                        pages: campaign.pages
                    });
                }

                function moveTop(dir) {
                    campaign.pages.splice(campaign.pages.findIndex(p => p.code == page.code),1);
                    if ( moving.offers ) {
                        campaign.pages.splice(moving.currentPOS += dir,0,page);
                    } else {
                        campaign.pages.splice(moving.currentPOS += ( ( moving.row + 1 ) * dir ),0,page);
                    }
                    moving.startY = e.clientY + ( ( moving.height / 2 ) * dir );
                    that.updatePages({
                        campaign,
                        pages: campaign.pages
                    });
                }

        },
        removeEntry({ customer, ad }) {
            console.log('entry',JSON.parse(JSON.stringify(ad)));
            Alert.yesno('Remove Competition Entry?',yes => {
                if ( !yes ) return;
                customer.entries = customer.entries.filter(a => a != ad);
                WebSoc.SEND('removeEntry',{ client_id: this.client_id, customer_id: customer._id, ad },() => {
                    console.log('removedEntry')
                })
            })
        },
        removeAd({ customer, ad }) {
            Alert.yesno('Remove Ad ?',yes => {
                if ( !yes ) return;
                WebSoc.SEND('removeAd',{ client_id: this.client_id, coupon_id: ad.coupon_id, customer_id: customer._id, ad },() => {
                    console.log('removeAd resp',resp);
                })
            })
        },
        removeRemoveAd({ customer, ad }) {
            Alert.yesno('Remove Ad ?',yes => {
                if ( !yes ) return;
                WebSoc.SEND('removeRemoveAd',{ redeemedAds: true, client_id: this.client_id, coupon_id: ad.coupon_id, customer_id: customer._id, ad },() => {
                    console.log('removeRemoveAd resp',resp);
                })
            })            
        },
        searchCustomers () {
            this.dbSearch({
                db: this.client_id+'-customers',
                search: this.search
            });
        },
        searchUsers() {
            this.staff.client_id = { value: this.client_id }
            this.dbSearch({
                db: 'users',
                search: this.staff
            });
        },
        editCustomer ( customer ) {
            editCustomer({
                client_id: this.client_id,
                customer_id: customer._id
            },() => {
                console.log('done');
            });
        },
        deleteCustomer ( customer ) {
            Alert.yesno('Delete '+customer.name+'?',yes => {
                if ( !yes ) return;
                WebSoc.SEND({ t: 'deleteCustomer', data: { customer_id: customer._id, client_id: customer.client_id } },() => {
                    console.log('resp',resp);
                    //this.customers = this.customers.filter(c => c != customer);
                })
            })
        },
        deleteCampaign ( campaign ) {
            Alert.yesno('Delete Campaign<br>'+campaign.title+'?',yes => {
                if ( !yes ) return;
                //this.campaigns.splice(this.campaigns.indexOf(campaign),1);
                this.updateCampaign({
                    deleteCampaign: campaign
                });
                this.campaign = false;
            });
        },
        saveCampaign ( campaign ) {
            this.campaign = false;
            this.updateCampaign({
                saveCampaign: campaign
            });
            setTimeout(() => this.$forceUpdate(),1000);
        },
        editCampaign( campaign ) {
            this.campaign = campaign;
        },
        makeNewCampaign () {

            var now = Date.now();
            this.campaign = {
                hide: false,
                id: '',
                iss: 0,
                title: '',
                client: '',
                client_id: this.client_id,
                about: '',
                created: now,
                u_created: PAdate(now).time_date,
                backgroundColor: '#ffffff',
                buttonColor: '#ffffff',
                buttonFontColor: '#ffffff',
                fontColor: '#ffffff',
                styleSurvey: false,
                staffSurvey: false,
                parent_id: false,
                child_ids: [],
                fontStyle: '',
                fontLink: '',
                fontName: '',
                pageLogo: '',
                clicks: 0,
                qtySent: 0,
                unique: {},
                user: '',
                pages: [],
                ham: [],
                issues: []
            }
        },
        exit () {
            this.$back();
        },
        show ( type ) {
            console.log('show',type);
        },
        ...mapActions([
            'getDashboard',
            'dbSearch',
            'showCustomerDetail',
            'showStaffDetail',
            'removeCampaign',
            'updatePages',
            'updateCampaign',
            'logout'
        ])
    }
}

</script>

<style lang="scss">   
.no-sms {
    &:before {
        content: '';
        background-image: url('/mobile-phone.png');
        width:20px;
        height: 20px;
        float: left;
        margin-right: 5px;
        background-size: contain;
    }
}
.current-offers {
    transform: translateX(-120px);
    transition: transform 0.3s;    
    &.show-open {
        transform: translateX(-455px);
    }
    .offers-scroller {
        > div:last-child { margin-bottom: 50px; }
    }
    
}    
.show-open {
    .hide {
        transform: rotate(0deg);
    }
}    
.hide {
    position: relative;
    width: 40px;
    height: 40px;
    background-color: whitesmoke;
    transform: rotate(180deg);
    &:before,&:after {
        content: '';
        width: 2px;
        height: 15px;
        background-color: black;
        position: absolute;
        top: 19px;
        left: 20px;
        transform: rotate(30deg);
    }
    &:after {
        top: 6px;
        transform: rotate(-30deg);
    }  
}      
.v-alert {
    .label {
        textarea { width: calc(100% - 20px); min-width: calc(100% - 20px); max-width: calc(100% - 20px); min-height: 100px; font-size: 16px; padding: 5px }
        &.with-btn {
            input { 
                width: calc(100% - 150px); 
            }
            p.btn { margin: 1px 10px 0px 0px; float: right;  }
        }
        &.checkbox {
            p { margin-top: 20px; margin-bottom: 3px; width: 200px; width: calc(100% - 200px ); text-align: left; }
            input[type=checkbox] {  }
        }
    }
}    
.ad-mover {
    .remove-x { display: none; }
}    
.remove-x {
    width: 30px;
    height: 30px;
    background-color: rgba(220,220,220,1);
    border-radius: 50%;
    border: 2px solid black;
    position: absolute;
    top: 325px;
    right: 0px;
    padding: 10px;
    &:before,&:after {
        content: '';
        width: 30px;
        height: 1px;
        background-color: black;
        position: absolute;
        top: 25px;
        left: 11px;
        transform: rotate(-45deg);
    }
    &:after {
        transform: rotate(45deg);
    }
}    
.grab { 
    width: 30px;
    height: 30px;
    background-image: url('data:image/svg+xml;base64,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');
    background-color: rgba(220,220,220,1);
    padding: 10px;
    background-repeat: no-repeat;
    background-position: 10px 8px;
    border-radius: 50%;
    border: 2px solid black;
    position: absolute;
    z-index: 10;
    &.size {
        background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGxpbmUgc3Ryb2tlPSIjMDAwIiB0cmFuc2Zvcm09InJvdGF0ZSg0NSAxMi4wMTU2IDEyLjIwMzEpIiB5Mj0iMTIuMjAzMTIiIHgyPSIyMy41NjQwOCIgeTE9IjEyLjIwMzEyIiB4MT0iMC40NjcxNyIgc3Ryb2tlLXdpZHRoPSIxLjUiIGZpbGw9Im5vbmUiLz4KICA8bGluZSB0cmFuc2Zvcm09InJvdGF0ZSg5MCA0LjAzMTQ1IDguNTYyNTkpIiBzdHJva2U9IiMwMDAiIHkyPSI4LjU2MjU5IiB4Mj0iOS4zMTI1NyIgeTE9IjguNTYyNTkiIHgxPSItMS4yNDk2NiIgc3Ryb2tlLXdpZHRoPSIxLjUiIGZpbGw9Im5vbmUiLz4KICA8bGluZSBzdHJva2U9IiMwMDAiIHkyPSI0LjAwMDIiIHgyPSIxNC4xODc0NSIgeTE9IjQuMDAwMiIgeDE9IjMuNjI1MjEiIHN0cm9rZS13aWR0aD0iMS41IiBmaWxsPSJub25lIi8+CiAgPGxpbmUgc3Ryb2tlPSIjMDAwIiB5Mj0iMjAuNTYyMjgiIHgyPSIyMS4xODcyNyIgeTE9IjIwLjU2MjI4IiB4MT0iMTAuNjI1MDQiIHN0cm9rZS13aWR0aD0iMS41IiBmaWxsPSJub25lIi8+CiAgPGxpbmUgc3Ryb2tlPSIjMDAwIiB0cmFuc2Zvcm09InJvdGF0ZSg5MCAyMC40Njg1IDE1Ljk5OTkpIiB5Mj0iMTUuOTk5OSIgeDI9IjI1Ljc0OTY1IiB5MT0iMTUuOTk5OSIgeDE9IjE1LjE4NzQyIiBzdHJva2Utd2lkdGg9IjEuNSIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4=');
    }
}    
.dashboard-summary {
    width: calc(100% - 20px);
    float: left;
    margin: 9px;
    border: 1px solid #c0c0c0;
    > header {
        border-bottom: 1px solid #c0c0c0;
        p { text-align: center; font-size: 20px; line-height: 30px; }
    }
    .dashboard-summary-title {
        padding: 10px;
        float: left;
        width: 100%;
        border-bottom: 1px solid #c0c0c0;
        > p { font-weight: bold; }
    }
    .dashboard-summary-items {
        float: left;
        line-height: 25px;
        width: 100%;
        > div > p { position: relative; left: 10px; }
        > div:nth-child(even) { background-color: rgba(100,100,100,0.2); }
    }
    .live-coupons {
        &:nth-child(odd) { background-color: rgba(100,100,100,0.2); }
        p:nth-child(2),p:nth-child(3),p:nth-child(4) { line-height: 40px; }
    }
}    
.gt {
    width: 20px;
    height: 20px;
    position: relative;
    transform: rotate(0deg);
    transition: 0.3s transform;
    &.open {
        transform: rotate(90deg);
    }
    &:before,&:after {
        content: '';
        width: 12px;
        height: 2px;
        top: 2px;
        left: 10px;
        background-color: rgba(100,100,100,1);
        position: absolute;
        transform: rotate(45deg);
        transform-origin: 0px 0px;
    }
    &:after {
        top: 18px;
        left: 8px;
        transform: rotate(-45deg);  
    }
}    
.dashboard {
    .list-main {
        border-top: 1px solid #c0c0c0;
        float: left;
        width: 100%;
        > div:nth-child(even) > div { background-color: rgba(100,100,100,0.2); }
    }
    .customer-list {
        width: calc(100% - 10px);
        float: left;
        padding: 5px;
        display: grid;
        grid-template-columns: 40px minmax(120px,260px) minmax(120px,300px) 90px minmax(120px,300px) minmax(200px,1fr) minmax(120px,1fr) minmax(75px,120px) minmax(75px,120px) minmax(75px,120px) minmax(75px,120px) minmax(75px,120px) minmax(75px,120px) minmax(220px,250px);
        > div {
            input { width: calc(100% - 25px); margin-right:0px; padding: 5px; font-size: 16px; }
            .ta-r + input { position: relative; left: 13px; }
        }
        &.list-header {
            p { font-weight: bold; }
        }
        > p {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
        }
    }
    .staff-list {
        &.list-header {
            > div {
                p {
                    font-weight: bold;
                }
                input { 
                    width: calc(100% - 25px); 
                    margin-right: 0px;
                    padding: 5px;
                    font-size: 16px; 
                }
            }
        }
        > div:nth-child(1) {
            width: calc(100% - 10px);
            float: left;
            padding: 5px;
            display: grid;
            grid-template-columns: 40px 200px 200px 100px 200px 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
        }
        > div > p {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
            font-size: 14px;
        }
    }
}
</style>